export default function CircularPlusIcon({
    style,
}){
    return <svg style={style} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.3782 19.993C15.7257 19.7939 19.9997 15.3961 19.9997 10C19.9997 4.47715 15.5225 0 9.99967 0C8.42931 0 6.94349 0.361973 5.62109 1.00703C5.74671 1.00236 5.87291 1 5.99967 1C11.5225 1 15.9997 5.47715 15.9997 11C15.9997 14.9525 13.7066 18.3694 10.3782 19.993Z" fill="#83CFA4"/>
    <circle cx="10" cy="10" r="9.25" stroke="#536987" strokeWidth="1.5"/>
    <path d="M10 5V14" stroke="#536987" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5 10H14" stroke="#536987" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>      
}
